import {
  Card,
  CardActions,
  CardContent,
  Chip,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import VisibilityOutlinedIcon from "@material-ui/icons/VisibilityOutlined";
import Pagination from "@material-ui/lab/Pagination";
import { makeStyles } from "@material-ui/styles";
import axios from "axios";
import clsx from "clsx";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Link as RouterLink } from "react-router-dom";
import TableEditBar from "../../../components/molecules/Table/TableEditBar";
import { hardBaseUrl } from "../../../services/urlConstant";

const theme = createTheme({
  typography: {
    fontFamily: ["Inter"].join(","),
  },
});

function Results({
  className,
  pageSizePagination,
  page,
  totalData,
  handleChangePage,
  items,
  ...rest
}) {
  const selectedCustomers = [];

  const [penciptaList, setPenciptaList] = useState([]);
  const [getColor, setGetColor] = useState("");

  useEffect(() => {
    const getPenciptaList = async () => {
      try {
        const url = hardBaseUrl + "/publisher/composer";
        const token = localStorage.getItem("token");
        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };
        const response = await axios.get(url, config);
        setPenciptaList(response.data.data);
      } catch (error) {}
    };
    const getMainDsp = async () => {
      try {
        const token = localStorage.getItem("token");
        const url = `${hardBaseUrl}/me`;
        const res = await axios.get(url, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        setGetColor(res.data.data.publisher.theme_color);
      } catch (e) {}
    };
    getMainDsp();
    getPenciptaList();
  }, []);

  const listPencipta = data => {
    let tempArr = [];
    data.map(item => {
      penciptaList.map(pencipta => {
        if (item.composer_id === pencipta.composer_id) {
          tempArr.push({
            ...item,
            alias_name: pencipta.alias_name,
          });
        }
      });
    });

    let pencipta = tempArr;

    if (pencipta.length > 3) {
      let pencipta1 = pencipta.slice(0, 3);
      let pencipta2 = pencipta.slice(3, pencipta.length);
      return (
        <div>
          {pencipta1.map(pencipta => (
            <Chip
              key={pencipta.composer_id}
              label={pencipta.alias_name}
              className={classes.tableChip}
              size="small"
            />
          ))}
          <Chip
            label={"+" + pencipta2.length}
            className={classes.tableChip}
            size="small"
          />
        </div>
      );
    } else {
      return pencipta.map(pencipta => (
        <Chip
          key={pencipta.composer_id}
          label={pencipta.alias_name}
          className={classes.tableChip}
          size="small"
        />
      ));
    }
  };

  const getDateFormat = date => {
    let dateFormat = new Date(date);
    let day = dateFormat.getDate();
    let month = dateFormat.getMonth();
    let year = dateFormat.getFullYear();
    let months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "Mei",
      "Jun",
      "Jul",
      "Agu",
      "Sept",
      "Okt",
      "Nov",
      "Des",
    ];
    return day + " " + months[month] + " " + year;
  };
  const useStyles = makeStyles(theme => ({
    root: {},
    content: {
      padding: 0,
    },
    inner: {
      minWidth: 700,
    },
    nameCell: {
      display: "flex",
      alignItems: "center",
    },
    avatar: {
      height: 42,
      width: 42,
      marginRight: theme.spacing(1),
    },
    actions: {
      padding: theme.spacing(1),
      justifyContent: "flex-end",
    },
    pagination: {
      "& .Mui-selected": {
        backgroundColor: getColor,
        color: "white",
      },
    },
    pageSize: {
      height: "30px",
      borderRadius: "6px",
      border: "1px solid #D1D5DC",
      paddingLeft: "5px",
      paddingRight: "5px",
      marginTop: "5px",
    },
    paginationText: {
      fontSize: "14px",
      fontWeight: "normal",
      fontStyle: "normal",
      color: "#687083",
    },
    headText: {
      fontSize: "12px",
      color: "#687083",
      fontWeight: "bold",
    },
    bodyTextBlack: {
      fontSize: "14px",
      fontWeight: "regular",
      color: "#111827",
    },
    bodyTextGrey: {
      fontSize: "14px",
      fontWeight: "regular",
      color: "#687083",
    },
    tableRow: {
      height: 20,
    },
    conTextBlack: {
      fontSize: "14px",
      fontWeight: "bold",
    },
    dropdown: {
      color: "black",
    },
    activeChip: {
      backgroundColor: "#8DE5AB",
      color: "#34774C",
      fontSize: "14px",
      fontWeight: "500",
    },
    activeChipIndicator: {
      color: "#34774C",
      fontSize: "12px",
    },
    nonActiveChip: {
      backgroundColor: "#D1D5DC",
      color: "#364052",
      fontSize: "14px",
      fontWeight: "500",
    },
    nonActiveChipIndicator: {
      color: "#364052",
      fontSize: "12px",
    },
    tableChip: {
      marginRight: "5px",
      backgroundColor: "#F9FAFB",
      border: "1px solid #D1D5DC",
    },
    btnDetail: {
      backgroundColor: "#111827",
      color: "white",
      width: "30px",
      height: "30px",
      padding: "6px",
      borderRadius: "6px",
    },
  }));

  const classes = useStyles();
  return (
    <div {...rest} className={clsx(classes.root, className)}>
      <Card>
        <CardContent className={classes.content}>
          <PerfectScrollbar>
            <div className={classes.inner}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <ThemeProvider theme={theme}>
                      <TableCell>
                        <Typography
                          variant="subtitle2"
                          className={classes.headText}
                        >
                          Action
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography
                          variant="subtitle2"
                          className={classes.headText}
                        >
                          Contact Number
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography
                          variant="subtitle2"
                          className={classes.headText}
                        >
                          Song Title
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography
                          variant="subtitle2"
                          className={classes.headText}
                        >
                          Composer
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography
                          variant="subtitle2"
                          className={classes.headText}
                        >
                          Start Date
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography
                          variant="subtitle2"
                          className={classes.headText}
                        >
                          End Date
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography
                          variant="subtitle2"
                          className={classes.headText}
                        >
                          Status
                        </Typography>
                      </TableCell>
                    </ThemeProvider>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {items?.length > 0 ? (
                    items.map((customer, idx) => (
                      <TableRow
                        hover
                        key={idx}
                        selected={
                          selectedCustomers.indexOf(customer.contract_id) !== -1
                        }
                      >
                        <ThemeProvider theme={theme}>
                          <TableCell>
                            <Tooltip title={"Update"} placement="bottom">
                              <IconButton
                                className={classes.btnDetail}
                                style={{
                                  backgroundColor: getColor,
                                }}
                              >
                                <RouterLink
                                  to={{
                                    pathname: `/admin/kontrak/detail/${customer.contract_id}`,
                                    state: {
                                      customer: customer,
                                    },
                                  }}
                                >
                                  <VisibilityOutlinedIcon
                                    style={{
                                      filter: " brightness(0) invert(1)",
                                      marginTop: "10px",
                                    }}
                                  />
                                </RouterLink>
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                          <TableCell>
                            <Typography
                              variant="subtitle2"
                              className={classes.bodyTextBlack}
                            >
                              {customer.contract_id}
                            </Typography>
                          </TableCell>
                          <TableCell>
                            <Typography
                              variant="subtitle2"
                              className={classes.bodyTextBlack}
                            >
                              {customer.song.title_song}
                            </Typography>
                          </TableCell>
                          <TableCell>
                            {listPencipta(customer.song.song_composer)}
                          </TableCell>
                          <TableCell>
                            <Typography
                              variant="subtitle2"
                              className={classes.bodyTextBlack}
                            >
                              {getDateFormat(customer.start_date)}
                            </Typography>
                          </TableCell>
                          <TableCell>
                            <Typography
                              variant="subtitle2"
                              className={classes.bodyTextBlack}
                            >
                              {getDateFormat(customer.end_date)}
                            </Typography>
                          </TableCell>
                          <TableCell>
                            {customer.is_active_flag ? (
                              <Chip
                                icon={
                                  <FiberManualRecordIcon
                                    fontSize="small"
                                    className={classes.activeChipIndicator}
                                  />
                                }
                                label="Aktif"
                                className={classes.activeChip}
                              />
                            ) : (
                              <Chip
                                icon={
                                  <FiberManualRecordIcon
                                    fontSize="small"
                                    className={classes.nonActiveChipIndicator}
                                  />
                                }
                                label="Non Aktif"
                                className={classes.nonActiveChip}
                              />
                            )}
                          </TableCell>
                        </ThemeProvider>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={6}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <Typography variant="subtitle1">
                            Tidak ada data untuk ditampilkan
                          </Typography>
                        </div>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </div>
          </PerfectScrollbar>
        </CardContent>
        <CardActions className={classes.actions}>
          <Grid
            alignContent="space-between"
            container
            justifyContent="space-between"
            spacing={3}
          >
            <Grid item>
              <div style={{ display: "flex" }}>
                <div style={{ marginTop: "7px" }}>
                  <ThemeProvider theme={theme}>
                    <Typography className={classes.paginationText}>
                      Item per halaman:
                    </Typography>
                  </ThemeProvider>
                </div>{" "}
                <div style={{ marginLeft: "10px" }}>{pageSizePagination}</div>
              </div>
            </Grid>

            <Grid item>
              <Pagination
                count={totalData}
                shape="rounded"
                className={classes.pagination}
                page={page}
                onChange={handleChangePage}
              />
            </Grid>
          </Grid>
        </CardActions>
      </Card>
      <TableEditBar selected={selectedCustomers} />
    </div>
  );
}

Results.propTypes = {
  className: PropTypes.string,
  customers: PropTypes.array,
};

Results.defaultProps = {
  customers: [],
};

export default Results;
